<template>
  <div style="flex:1;">
    <div class="page-title">反馈</div>
    <div class="left-box">
      <div class="box-title">
        <i class="iconfont iconic_loubaowubaofankui"></i>
        <span>手机号码漏报误报反馈</span>
      </div>
      <div class="tip-box">
        <i class="iconfont iconic_wenxintishi"></i>
        <span>温馨提示，您可以根据您的需求选择以下其中一种方式进行手机号码漏报或者误报反馈。</span>
      </div>
      <div class="hand-opt-box">
        <div class="title">
          <span>方式一：手动上传</span>
          <el-tooltip
            class="item"
            effect="dark"
            content="可输入一个或者多个手机号码，用逗号间隔130****1234，130****3287，130**…"
            placement="top"
          >
            <i class="iconfont iconic_wenxintishi"></i>
          </el-tooltip>
        </div>
        <span class="date-tip">号码捕获时间(选填)</span>
        <div
          class="content-item"
          :style="{'paddingLeft':index===0?'0px':'99px'}"
          v-for="(item,index) in handleList"
          :key="index"
        >
          <el-select
            style="margin-right:11px;width:88px"
            v-model="item.type"
            v-show="index===0"
            @change="typeChange"
          >
            <el-option label="漏报" :value="1"></el-option>
            <el-option label="误报" :value="2"></el-option>
          </el-select>
          <el-input
            v-model="item.phone"
            style="margin-right:24px"
            placeholder="可输入一个或者多个手机号码，用逗号间隔130****1234，130****3287，130**…"
          ></el-input>
          <el-date-picker
            style="width:195px"
            type="datetime"
            placeholder="选择日期"
            :picker-options="pickerOptions"
            v-model="item.date_business"
            value-format="yyyy-MM-dd HH:mm:ss"
          ></el-date-picker>
        </div>
        <div class="add-btn" @click="addHandItem">添加输入框</div>
        <div class="footer-btn">
          <div class="btn" @click="handSubmit">提交反馈</div>
        </div>
      </div>
      <div class="batch-opt-box">
        <div class="title">方式二：批量上传</div>
        <div class="sub-title">1.选择漏报/误报</div>
        <el-select style="width:88px;margin-bottom:24px" v-model="fileUploadParmas.type">
          <el-option label="漏报" :value="1"></el-option>
          <el-option label="误报" :value="2"></el-option>
        </el-select>
        <div class="upload-box">
          <div class="opt-box">
            <div class="sub-title">2.下载参考模板</div>
            <div class="opt-content" @click="downloadFile">
              <i class="iconfont iconic_xiazai"></i>
              <p>手机号码漏报反馈文档.txt</p>
            </div>
          </div>
          <div class="opt-box">
            <div class="sub-title">3.上传文档</div>
            <el-upload
              name="upload_file"
              :data="fileUploadParmas"
              :action="baseUrl + '/user/black-phone-operation/self/event-upload-file/'"
              :with-credentials="true"
              :before-upload="beforeUpload"
              :on-success="uploadSuccess"
              :on-error="uploadError"
              :on-progress="uploadProgress"
              ref="upload"
              :show-file-list="false"
            >
              <div class="opt-content" v-loading="fileUploadLoading">
                <i class="iconfont iconic_shangchuan"></i>
                <p>请上传格式为.txt的文档</p>
              </div>
            </el-upload>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { baseUrl } from '@/config'
import { phoneUploadByInput } from '@/services/interface'
export default {
  data () {
    return {
      pickerOptions: { // 时间选择框选项
        disabledDate (time) {
          return time.getTime() > Date.now()
        }
      },
      handleList: [ // 手动上传的数据
        { type: 1, phone: '', date_business: '' }
      ],
      fileUploadParmas: { // 上传文件时的额外参数
        type: 1
      },
      fileUploadLoading: false, // 文件上传的loading
      baseUrl
    }
  },
  methods: {
    /**
     * 手动上传时添加输入框
     */
    addHandItem () {
      const type = this.handleList[0].type
      this.handleList.push(
        { type, phone: '', date_business: '' }
      )
    },

    /**
     * 反馈类型下拉框改变事件
     * @param value: 1:漏报,2:误报
     */
    typeChange (value) {
      this.handleList.forEach((item) => {
        item.type = value
      })
    },

    /**
     * 手动上传提交反馈
     */
    async handSubmit () {
      const temList = JSON.parse(JSON.stringify(this.handleList))
      const list = temList.filter((item) => {
        return item.phone
      })
      if (!list.length) {
        this.$message.error('请填写手机号')
        return
      }
      const commaReg = new RegExp('，', 'g')
      const temParams = list.map((item) => {
        if (!item.date_business) {
          delete item.date_business
        }
        item.phone = item.phone.replace(commaReg, ',')
        item.phone = item.phone.split(',')
        return item
      })
      const params = []
      temParams.forEach((item) => {
        item.phone.forEach((innerItem) => {
          if (innerItem) { // 可能为空字符串
            if (item.date_business) {
              params.push({
                type: item.type,
                phone: innerItem,
                date_business: item.date_business
              })
            } else {
              params.push({
                type: item.type,
                phone: innerItem
              })
            }
          }
        })
      })
      const result = await phoneUploadByInput(params).then((res) => {
        return res
      }).catch((err) => {
        return err
      })
      if (result.status === 200) {
        this.$message.success('提交成功，感谢您的反馈。')
        this.handleList = [{ type: 1, phone: '', date_business: '' }]
        this.$emit('uploadSuccess')
      } else if (result.status === 400) {
        this.$message.error('手机号填写错误')
      }
    },

    /**
     * 下载文件模板
     */
    downloadFile () {
      const a = document.createElement('a')
      a.href = 'http://thapi-v3-tools.oss-cn-shenzhen.aliyuncs.com/black_phone_operation/4140a636-c226-4c67-9fd4-45fc54558779/example.txt?OSSAccessKeyId=LTAIPh3LkqA97MjY&Expires=1907661453&Signature=9J%2FmlwryXxuVmDdNdcMKIfjYxqA%3D'
      a.click()
    },

    /**
     * 文件上传之前事件
     * @param file: 文件信息
     */
    beforeUpload (file) {
      const isTxt = file.type === 'text/plain'
      if (!isTxt) {
        this.$message.error('请上传txt格式的文件')
      }
      return isTxt
    },

    /**
     * 文件上传成功
     */
    uploadSuccess (response, file, fileList) {
      this.fileUploadLoading = false
      this.$message.success('提交成功，感谢您的反馈。')
      this.$emit('uploadSuccess')
    },

    /**
     * 文件上传失败
     */
    uploadError () {
      this.fileUploadLoading = false
      this.$message.error('文件上传失败，请检查文件内容')
    },

    /**
     * 文件上传中
     */
    uploadProgress (event, file, fileList) {
      this.fileUploadLoading = true
    }
  },
  created () {
  }
}
</script>

<style scoped>
.page-title {
  width: 40px;
  height: 25px;
  line-height: 25px;
  position: relative;
  font-size: 18px;
  font-weight: 500;
  color: rgba(29, 36, 60, 1);
  letter-spacing: 1px;
  margin-bottom: 32px;
}
.page-title::after {
  content: '';
  position: absolute;
  top: 30px;
  left: 0;
  width: 100%;
  height: 3px;
  background: rgba(0, 61, 146, 1);
  border-radius: 2px;
}
.left-box {
  padding: 24px 35px 81px 40px;
  box-sizing: border-box;
  background: rgba(255, 255, 255, 1);
  border-radius: 4px;
  height: calc(100% - 57px);
}
.box-title {
  position: relative;
  font-size: 14px;
  font-weight: 400;
  color: rgba(59, 60, 64, 1);
  line-height: 18px;
  margin-bottom: 16px;
}
.box-title i {
  color: RGBA(0, 61, 146, 1);
  font-size: 18px;
  position: absolute;
  left: -28px;
}
.tip-box {
  width: 582px;
  height: 34px;
  display: flex;
  align-items: center;
  background: rgba(237, 247, 255, 1);
  font-size: 14px;
  font-weight: 400;
  color: rgba(67, 95, 135, 1);
  margin-bottom: 48px;
}
.tip-box i {
  margin: 0 9px;
}
.hand-opt-box {
  position: relative;
  padding-bottom: 18px;
  border-bottom: 1px solid rgba(238, 238, 238, 1);
  margin-bottom: 37px;
}
.hand-opt-box .date-tip {
  position: absolute;
  font-size: 10px;
  font-weight: 400;
  color: rgba(59, 60, 64, 1);
  line-height: 14px;
  right: 0;
  top: 12px;
}
.hand-opt-box .title {
  font-size: 14px;
  font-weight: 400;
  color: rgba(59, 60, 64, 1);
  line-height: 18px;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
}
.hand-opt-box .title span {
  margin-right: 8px;
}
.hand-opt-box .content-item {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}
.add-btn {
  width: 88px;
  height: 32px;
  background: rgba(255, 255, 255, 1);
  border-radius: 4px;
  border: 1px solid rgba(0, 55, 153, 1);
  box-sizing: border-box;
  text-align: center;
  line-height: 32px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  color: rgba(0, 61, 146, 1);
  margin-bottom: 16px;
}
.batch-opt-box .title {
  font-size: 14px;
  font-weight: 400;
  color: rgba(59, 60, 64, 1);
  line-height: 18px;
  margin-bottom: 24px;
}
.batch-opt-box .sub-title {
  font-size: 14px;
  font-weight: 400;
  color: rgba(36, 36, 36, 1);
  line-height: 20px;
  margin-bottom: 12px;
}
.upload-box {
  display: flex;
}
.upload-box .opt-box {
  margin-right: 32px;
}
.upload-box .opt-box .opt-content {
  width: 140px;
  height: 140px;
  background: rgba(242, 245, 251, 1);
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 32px 20px 0;
  box-sizing: border-box;
  cursor: pointer;
}
.upload-box .opt-box .opt-content i {
  font-size: 32px;
  color: RGBA(0, 61, 146, 1);
  margin-bottom: 20px;
}
.upload-box .opt-box .opt-content p {
  font-size: 12px;
  font-weight: 400;
  color: rgba(142, 149, 160, 1);
  line-height: 17px;
  text-align: center;
}
.footer-btn {
  overflow: hidden;
}
.footer-btn .btn {
  float: right;
  width: 128px;
  height: 32px;
  text-align: center;
  line-height: 32px;
  background: rgba(0, 61, 146, 1);
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  letter-spacing: 1px;
  cursor: pointer;
}
</style>

<style>
.hand-opt-box .content-item .el-input__inner {
  height: 32px;
  line-height: 32px;
}
.hand-opt-box .content-item .el-input {
  flex: 1;
}
.hand-opt-box .content-item .el-input.el-date-editor {
  flex: unset;
}
.hand-opt-box .content-item .el-input__inner {
  height: 32px;
  line-height: 32px;
}
.hand-opt-box .content-item .el-input__suffix-inner .el-input__icon {
  line-height: 32px;
}
.hand-opt-box .el-date-editor .el-input__prefix .el-input__icon {
  line-height: 32px;
}
</style>
